module.exports = __webpack_public_path__ + "static/media/workbrook-bg-new.b154d66c.png";